// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3DGhD","title":"AfterFrontImage_title__20Ck0"};